<app-modal
  [title]="'ORGANIZATION.SELECT_ORGANIZATION' | translate"
  [isDataLoaded]="true"
  [saveButtonName]="getSaveButtonName()"
  [cancelButtonName]="getCancelButtonName()"
  (save)="openAddDialog()"
  (cancelClick)="selectNoneOrganization()"
  customCancelBehavior
>
  <ng-container body>
    <div class="list-container">
      @if (waitService.isLoading()) {
        <app-skeleton></app-skeleton>
      } @else {
        @for (organization of organizations; track organization) {
          <div
            class="organization"
            (click)="organizationSelected(organization)"
            (keydown.enter)="organizationSelected(organization)"
            (keydown.space)="organizationSelected(organization)"
            tabindex="0"
          >
            @if (organization.company_logo) {
              <img [src]="organization.company_logo" alt="" />
            } @else {
              <div class="logo">
                <mat-icon>corporate_fare</mat-icon>
              </div>
            }
            <div class="organization-info">
              <span [attr.data-cy]="'info-' + organization.company_name">{{
                organization.company_name
              }}</span>
              <div class="organization-info-minor">
                <span>{{ organization.vat_number }} | </span>
                <span>{{ organization.role }}</span>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </ng-container>
</app-modal>
